import React from "react";
import {
  Button,
  Grid2 as Grid,
  Box,
} from "@mui/material";
import { useFormHandlerContext } from "../../../../controllers/formController";
import { singleGridItem } from "../../fields/defaultStyles";
import DeleteDialog from "../../../modals/DeleteDialog/DeleteDialog";

const FormActions: React.FC = () => {
  const {
    isProcessing,
    isSubmitting,
    isCreateMode,
    isDeleting,
    deleteFunctionality,
    onCancel,
  } = useFormHandlerContext();

  const submitLabel = isSubmitting
    ? isCreateMode
      ? "Creating..."
      : "Updating..."
    : isCreateMode
      ? "Create"
      : "Update";

  const deleteLabel = isDeleting ? "Deleting..." : "Delete";

  return (
    <>
      <Grid {...singleGridItem} mt={2} sx={{ display: "flex", gap: 2 }}>
        {!isCreateMode && deleteFunctionality ? (
          <Button
            sx={{ mr: "auto" }}
            type="button"
            variant="contained"
            color="error"
            disabled={isProcessing}
            onClick={deleteFunctionality.openDialog}
          >
            {deleteLabel}
          </Button>
        ) : (
          <Box sx={{ mr: "auto" }} />
        )}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isProcessing}
        >
          {submitLabel}
        </Button>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          onClick={onCancel}
          disabled={isProcessing}
        >
          Cancel
        </Button>
      </Grid>
      {deleteFunctionality && (
        <DeleteDialog {...deleteFunctionality} disabled={isProcessing} />
      )}
    </>
  );
};

export default FormActions;
